var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListedcompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.717,
    height: 77.717,
    viewBox: "0 0 77.717 77.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25630",
    "data-name": "Rectangle 25630",
    width: 77.717,
    height: 77.717,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88047",
    "data-name": "Group 88047",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25609",
    "data-name": "Rectangle 25609",
    width: 21.738,
    height: 33.938,
    transform: "translate(21.611 42.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25610",
    "data-name": "Rectangle 25610",
    width: 8.233,
    height: 11.259,
    transform: "translate(28.363 65.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308497",
    "data-name": "Path 308497",
    d: "M39.929,23.908H38.282V17.476h8.151v1.646h-6.5Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25611",
    "data-name": "Rectangle 25611",
    width: 1.647,
    height: 2.095,
    transform: "translate(38.282 25.925)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308498",
    "data-name": "Path 308498",
    d: "M69.566,17.475v1.647h6.5v4.785h1.646V17.475Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25612",
    "data-name": "Rectangle 25612",
    width: 1.646,
    height: 2.095,
    transform: "translate(76.071 25.926)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25613",
    "data-name": "Rectangle 25613",
    width: 1.647,
    height: 2.095,
    transform: "translate(38.282 29.879)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25614",
    "data-name": "Rectangle 25614",
    width: 1.646,
    height: 2.095,
    transform: "translate(76.071 29.879)",
    fill: "#fd9f28"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25615",
    "data-name": "Rectangle 25615",
    width: 29.302,
    height: 47.343,
    transform: "translate(43.348 29.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25616",
    "data-name": "Rectangle 25616",
    width: 2.47,
    height: 47.343,
    transform: "translate(43.348 29.55)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25617",
    "data-name": "Rectangle 25617",
    width: 11.855,
    height: 17.596,
    transform: "translate(52.072 59.297)",
    fill: "#ffedd6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25618",
    "data-name": "Rectangle 25618",
    width: 2.799,
    height: 17.597,
    transform: "translate(52.072 59.296)",
    fill: "#fd9f28"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25619",
    "data-name": "Rectangle 25619",
    width: 8.233,
    height: 8.236,
    transform: "translate(47.791 34.133)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25620",
    "data-name": "Rectangle 25620",
    width: 8.233,
    height: 8.236,
    transform: "translate(59.975 34.133)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25621",
    "data-name": "Rectangle 25621",
    width: 8.233,
    height: 8.236,
    transform: "translate(47.791 46.322)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25622",
    "data-name": "Rectangle 25622",
    width: 8.233,
    height: 8.236,
    transform: "translate(59.975 46.322)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25623",
    "data-name": "Rectangle 25623",
    width: 1.647,
    height: 1.54,
    transform: "translate(46.803 72.8)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25624",
    "data-name": "Rectangle 25624",
    width: 1.647,
    height: 6.482,
    transform: "translate(46.803 64.893)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25625",
    "data-name": "Rectangle 25625",
    width: 1.647,
    height: 1.54,
    transform: "translate(67.385 72.8)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25626",
    "data-name": "Rectangle 25626",
    width: 1.647,
    height: 1.54,
    transform: "translate(46.803 61.599)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25627",
    "data-name": "Rectangle 25627",
    width: 1.647,
    height: 1.54,
    transform: "translate(67.385 61.599)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25628",
    "data-name": "Rectangle 25628",
    width: 1.647,
    height: 6.482,
    transform: "translate(67.385 64.893)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_88046",
    "data-name": "Group 88046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88045",
    "data-name": "Group 88045",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308499",
    "data-name": "Path 308499",
    d: "M68.373,10.869C68.373,20.036,58,27.194,58,27.194S47.627,19.659,47.627,10.869a10.378,10.378,0,0,1,20.746,0",
    fill: "#ffedd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308500",
    "data-name": "Path 308500",
    d: "M49.931,10.046A10.013,10.013,0,0,1,55.589,1.1a10.119,10.119,0,0,0-7.963,9.77C47.626,19.66,58,27.194,58,27.194s.674-.465,1.677-1.309c-2.244-1.8-9.745-8.363-9.745-15.839",
    fill: "#fd9f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308501",
    "data-name": "Path 308501",
    d: "M58,6.306a4.939,4.939,0,1,1-4.941,4.94A4.94,4.94,0,0,1,58,6.306",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308502",
    "data-name": "Path 308502",
    d: "M55.694,11.246a4.941,4.941,0,0,1,3.622-4.761,4.94,4.94,0,1,0,0,9.522,4.941,4.941,0,0,1-3.622-4.761",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308503",
    "data-name": "Path 308503",
    d: "M58,17.009a5.763,5.763,0,1,1,5.762-5.763A5.769,5.769,0,0,1,58,17.009M58,7.13a4.117,4.117,0,1,0,4.115,4.116A4.121,4.121,0,0,0,58,7.13",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308504",
    "data-name": "Path 308504",
    d: "M17.2,8.269l.462.681.463.681A13.039,13.039,0,0,1,25.477,7.38V5.734A14.672,14.672,0,0,0,17.2,8.269",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308505",
    "data-name": "Path 308505",
    d: "M15.616,10.649l-.584-.58a14.7,14.7,0,0,0-1.383,1.608l1.323.98A12.817,12.817,0,0,1,16.2,11.23Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308506",
    "data-name": "Path 308506",
    d: "M13.16,16.094,11.6,15.558a14.406,14.406,0,0,1,.845-1.963l1.46.762a12.612,12.612,0,0,0-.748,1.737",
    fill: "#fd9f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308507",
    "data-name": "Path 308507",
    d: "M34.363,20.211c0,7.95-8.886,14.157-8.886,14.157S16.59,27.834,16.59,20.211a8.888,8.888,0,0,1,17.773,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308508",
    "data-name": "Path 308508",
    d: "M18.9,19.717a8.725,8.725,0,0,1,5.837-8.185,8.781,8.781,0,0,0-8.142,8.679c0,7.623,8.886,14.157,8.886,14.157s.592-.413,1.468-1.162C24.732,31.357,18.9,25.9,18.9,19.717Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308509",
    "data-name": "Path 308509",
    d: "M25.477,15.715a4.823,4.823,0,1,0,4.773,4.823,4.8,4.8,0,0,0-4.773-4.823",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308510",
    "data-name": "Path 308510",
    d: "M5.789,31.347c1.647-3.246,5.375-6.654,9.847-6.561,4.005.083,8.321,4.211,9.675,7.885.072.195,3.813,9.817-.463,14.57-3.419,3.8-9.757,3.97-10.635,3.884-1.018-.1-7.419-.655-9.636-4.891C2.559,42.376,4.024,34.826,5.789,31.347Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308511",
    "data-name": "Path 308511",
    d: "M27.794,65.577H2.7V61.661a13.629,13.629,0,0,1,8.892-12.78H18.9a13.628,13.628,0,0,1,8.891,12.78Z",
    fill: "#ffedd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308512",
    "data-name": "Path 308512",
    d: "M15.586,48.881H11.593A13.628,13.628,0,0,0,2.7,61.661v3.916H5.336v-2.6A13.629,13.629,0,0,1,14.228,50.2h1.358Z",
    fill: "#fd9f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308513",
    "data-name": "Path 308513",
    d: "M31.576,56.512a19.188,19.188,0,0,0-1.609-3.182l1.4-.876a20.924,20.924,0,0,1,1.746,3.455Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308514",
    "data-name": "Path 308514",
    d: "M28.544,51.352a19.723,19.723,0,0,0-1.8-1.921l1.121-1.2a21.125,21.125,0,0,1,1.955,2.082Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308515",
    "data-name": "Path 308515",
    d: "M15.248,52.26a3.655,3.655,0,0,1-3.655-3.654V39.277H18.9v9.329a3.654,3.654,0,0,1-3.654,3.654",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308516",
    "data-name": "Path 308516",
    d: "M15.248,46.229a6.977,6.977,0,0,1-6.977-6.977v-6.8A3.952,3.952,0,0,1,12.223,28.5h6.05a3.952,3.952,0,0,1,3.952,3.952v6.8a6.977,6.977,0,0,1-6.977,6.977",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25629",
    "data-name": "Rectangle 25629",
    width: 28.85,
    height: 14.563,
    transform: "translate(0.823 58.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308517",
    "data-name": "Path 308517",
    d: "M15.248,63.411A2.419,2.419,0,1,1,12.83,65.83a2.419,2.419,0,0,1,2.418-2.419",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308518",
    "data-name": "Path 308518",
    d: "M15.248,69.073a3.242,3.242,0,1,1,3.241-3.242,3.246,3.246,0,0,1-3.241,3.242m0-4.838a1.6,1.6,0,1,0,1.6,1.6,1.6,1.6,0,0,0-1.6-1.6",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308519",
    "data-name": "Path 308519",
    d: "M65.091,21.477c2.2-2.87,4.1-6.528,4.1-10.608a11.2,11.2,0,0,0-22.393,0c0,3.992,1.975,7.688,4.23,10.608H42.525v14H27.015c-.089-.372-.181-.721-.27-1.041,2.468-1.957,8.442-7.4,8.442-14.229a9.712,9.712,0,0,0-19.42,0,12.033,12.033,0,0,0,.654,3.811,7.09,7.09,0,0,0-.768-.059c-5.23-.106-9.579,4.011-11.314,8.678-1.512,4.07-2.609,9.923-.49,13.974a8.508,8.508,0,0,0,3.73,3.542,14.411,14.411,0,0,0-5.152,7.568H0V75.9a1.814,1.814,0,0,0,1.812,1.812H73.475V21.477ZM25.477,12.322a7.986,7.986,0,0,1,8.063,7.889c0,5.72-5.011,10.59-7.326,12.534-.056-.16-.1-.282-.13-.359a14.368,14.368,0,0,0-7.708-7.862,10.989,10.989,0,0,1-.962-4.313,7.986,7.986,0,0,1,8.063-7.889M24.236,46.69a9.518,9.518,0,0,1-3.2,2.255q-.635-.342-1.308-.623V45.633a7.8,7.8,0,0,0,3.323-6.381V35.913h2.386C26.193,39.045,26.775,43.868,24.236,46.69ZM9.1,35.763a6.533,6.533,0,0,0,4.62-3.855,9,9,0,0,0,7.687,4v3.339a6.154,6.154,0,0,1-12.307,0ZM18.08,46.521V48.6a2.832,2.832,0,0,1-5.663,0V46.521a7.877,7.877,0,0,0,5.663,0M5.307,45.852c-1.254-2.4-1.039-6.492-.23-9.939H7.448v3.339a7.794,7.794,0,0,0,3.323,6.381v2.689a14.636,14.636,0,0,0-1.586.775,7.426,7.426,0,0,1-3.878-3.245M11,50.018a4.476,4.476,0,0,0,8.5,0,12.761,12.761,0,0,1,6.855,7.707H4.146A12.762,12.762,0,0,1,11,50.018Zm17.85,22.27H1.647V59.371h27.2Zm6.923,3.782H30.488c0-.054.009-.109.009-.165V66.457h5.276Zm6.752,0H37.42V64.811H30.5V57.725H28.071a14.407,14.407,0,0,0-5.406-7.757,10.64,10.64,0,0,0,2.8-2.177,8.6,8.6,0,0,0,1.951-4.013H42.525Zm5.925-65.2a9.556,9.556,0,0,1,19.1,0c0,7.519-7.545,13.773-9.539,15.295-1.99-1.58-9.561-8.07-9.561-15.295M63.1,76.07H52.9V60.12H63.1Zm8.724,0H64.751v-17.6h-13.5v17.6H44.172v-45.7H71.828Z",
    fill: "#515255"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListedcompanies);
export default __webpack_public_path__ + "static/media/Listed companies.a9dc70c9b1512266b84f019bd46d7989.svg";
export { ForwardRef as ReactComponent };